import {
  requests 
} from '../../../api/agent'

export default {
  getRequestsStatus: (params) => requests.getWithParams('/ReRequestsStatus/ListAllPaged', params),
  getRequestsStatusViews: (params) => requests.getWithParams('/ReRequestsStatus/ListAllPagedViews', params),
  getRequestStatusByName: (params) => requests.getWithParams('/ReRequestsStatus/getByName', params),
  createRequestStatus: (params) => requests.post('/ReRequestsStatus/CreateRequestStatus', params),
  deleteRequestStatus: (params) => requests.post('/ReRequestsStatus/DeleteRequestStatus', params),
  updateRequestStatus: (params) => requests.post('/ReRequestsStatus/UpdateRequestStatus', params),
  restoreRequestStatus: (params) => requests.post('/ReRequestsStatus/RestoreRequestStatus', params)
}